import { Button, Text } from "@alpacahq/ui/old";

import { PDFAgreementModal } from "~/v2/components/form";
import { AGREEMENTS } from "~/v2/constants";

export interface UpdateCustomerAgreementPresentationProps {
  isModalOpen: boolean;
  isSubmitting: boolean;
  isMissingSignerPartyId: boolean;
  onView: () => void;
  onCancel: () => void;
  onAgree: () => void;
}

export const UpdateCustomerAgreementPresentation = ({
  isModalOpen,
  isSubmitting,
  isMissingSignerPartyId,
  onView,
  onCancel,
  onAgree,
}: UpdateCustomerAgreementPresentationProps) => (
  <section className="flex flex-col items-center gap-4 rounded border border-gray-200 p-4">
    <Text className="font-semibold">
      Review Needed - Updated Customer Agreement
    </Text>
    {isMissingSignerPartyId ? (
      <Text>
        Alpaca has updated the Customer Agreement and it needs to be signed. We
        couldn't find the authorized signer for this entity, so please contact{" "}
        <a
          href="mailto:support@alpaca.markets"
          className="text-[#377dff] underline"
        >
          support@alpaca.markets
        </a>{" "}
        to complete this update.
      </Text>
    ) : (
      <>
        <Text>
          Alpaca has updated the Customer Agreement. Please review the updated
          agreement and click "I Agree" before continuing to use our services.
        </Text>

        <Button onClick={onView}>Review Customer Agreement</Button>
      </>
    )}

    <PDFAgreementModal
      isOpen={isModalOpen}
      title="Alpaca Customer Agreement"
      url={AGREEMENTS.customer_agreement.url}
      onCancel={onCancel}
      onAgree={onAgree}
      hasAgreed={false}
      isSubmitting={isSubmitting}
      disclosure={
        <Text className="text-gray-600 text-sm">
          By clicking "I Agree" you hereby agree to be bound to the terms of the
          Customer Agreement as provided to you. Your electronic signature will
          have the same effect as physically signing and returning the
          agreement.
        </Text>
      }
    />
  </section>
);
